import {ExceptionInfo} from './types.js';
import {Identity} from '../state/types/common.js';

const knownKeys: Record<string, {required: boolean}> = {
    application: {required: true},
    instance: {required: false},
    region: {required: false},
    environment: {required: false},
    machine: {required: false},
    user: {required: false}
}

function missingKey(identity: Identity): string | undefined {
    return Object.keys(knownKeys).find((key: string) => {
        return knownKeys[key] && knownKeys[key].required && identity[key] === undefined;
    })
}

export function checkIdentity(identity: Identity) {
    const missing = missingKey(identity);
    if (missing) {
        throw new ExceptionInfo(`Identity ${JSON.stringify(identity)} is missing required key: ${missing}`, {});
    }
}

export function machine(endpoint?: string, ip?: string): string | undefined {
    let host = endpoint;
    if (host) {
        const colonIndex = host.lastIndexOf(':');
        if (colonIndex !== -1) {
            if (host.startsWith('[')) { // IPv6
                host = host.substring(1);
                host = host.substring(0, host.indexOf(']'));
            }
            else if (colonIndex === host.indexOf(':')) { /// IPv4
                host = host.substring(0, colonIndex);
            }
        }

        if (host.indexOf('127.0.0.1') >= 0) {
            return ip ?? host;
        }
    }
    return host ?? ip;
}
